import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';

interface ChartData {
  series: number[];
  labels: string[];
}

export const pieEntersChartOptions = (chartData: ChartData, t: TFunction) => {
  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    colors: ['#6A37D4', '#EED32E'],
    fill: {
      type: 'gradient',
      opacity: [0.8, 0.8],
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.1,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.8,
        stops: [0, 100],
      },
    },
    series: chartData.series || [],
    labels: chartData.labels || [],
    title: {
      text: t('MCTDetail.double_pies.title_1'),
      align: 'center',
      offsetY: -3,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
        fontFamily: 'Poppins, sans-serif',
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '45%',
          labels: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      custom: ({ series, seriesIndex }: any) => {
        if (seriesIndex >= 0 && seriesIndex < chartData.labels.length) {
          const label = chartData.labels[seriesIndex];
          const value = series[seriesIndex];
          return `<div class="custom-tooltip">
            <div style="background: #ffffff; color: #333; padding: 8px 12px; border-radius: 6px; font-size: 12px; border: 2px solid #6A37D4;">
              ${label === 'L' ? '←L' : 'R→'}: ${value} ${value > 1 ? t('MCTDetail.double_pies.mice') : t('MCTDetail.double_pies.mouse')}
            </div>
          </div>`;
        }
        return '';
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: (_val: any, opts: any) => {
        const seriesIndex = opts.seriesIndex;

        if (seriesIndex < 0 || seriesIndex >= chartData.series.length) {
          return '';
        }

        const count = chartData.series[seriesIndex];
        const timePeriod = chartData.labels[seriesIndex];

        if (typeof count === 'number' && timePeriod) {
          const direction = timePeriod === 'L' ? '◄L' : 'R►';
          return [
            `${t('MCTDetail.double_pies.trap')} ${direction}`,
            `${count} ${count === 1 ? t('MCTDetail.double_pies.mouse') : t('MCTDetail.double_pies.mice')}`,
          ];
        }

        return '';
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
      dropShadow: {
        enabled: true,
        color: '#111',
        top: 0,
        left: 0,
        blur: 3,
        opacity: 0.7,
      },
    },

    responsive: [
      {
        breakpoint: 636,
        options: {
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
        },
      },
    ],
  };

  return chartOptions;
};
